module.exports = __webpack_public_path__ + "assets/9db9ccb2f18b2429589e63dd9cea8ee1.mp4";